<div>
  <div
    [ngStyle]="{
      'font-family': configs?.fonts?.default_font,
      'font-size': configs?.fonts?.default_font_size_px + 'px' || '16px',
      color: configs?.colors?.bot_message_text,
      background: configs?.colors?.bot_message_background,
      border: '1px solid ' + configs?.colors?.bot_message_border
    }"
    class="dynamic-buttons"
  >
    <div class="text-area" [innerHTML]="messageText"></div>
    <div *ngFor="let button of config.button_items" class="button-option">
      <button
        mat-raised-button
        (click)="onButtonClick(button)"
        [disabled]="!canSendMessage || !config.active"
        [ngStyle]="{
        'font-family': configs?.fonts?.default_font,
        'font-size': configs?.fonts?.default_font_size_px + 'px' || '16px',
        color: configs?.colors?.bot_message_text,
        border: '1px solid ' + configs?.colors?.bot_message_border,
      }"
      >
        {{ button.label }}
      </button>
    </div>
  </div>
  <div class="display-flex flex-space-between" style="width: 100%">
    <app-message-timestamp
      *ngIf="input.created_at && input.created_at > 0"
      [createdAt]="input.created_at"
    >
    </app-message-timestamp>
    <span
      class="unread"
      *ngIf="!isRead"
      [ngStyle]="{
                'color': configs?.colors?.user_message_background,
              }"
      >{{ messageUnreadText }}</span
    >
  </div>
</div>
